import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

export const FULFILLMENT_KEY = ["dashboard", "fulfillment"] as const;

/**
 * GET /v1/dashboard/fulfillment — the whole ops dashboard snapshot (got-AWB
 * windows, stuck-order set + rows, per-marketplace ingest). One call backs
 * most of the page; polled every 60s per the spec.
 */
export function useFulfillment() {
  return useQuery({
    queryKey: FULFILLMENT_KEY,
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/dashboard/fulfillment");
      if (error) throw error;
      return data;
    },
    refetchInterval: 60_000,
  });
}
